import {createProjectModel} from 'crm/utils/project-model'
import {detail, create, update} from './service'

const model = createProjectModel({
    projectNamespace: 'createTask',
    state: {},
    effects: {
        *detail({payload}, {call}) {
            return yield call(detail, payload)
        },
        *create({payload}, {call}) {
            return yield call(create, payload)
        },
        *update({payload}, {call}) {
            return yield call(update, payload)
        },
    },
    reducers: {},
})

export default model
